// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1__d2234dd2f6077955e3e4{/*!*/}.FocusedNav-cls2__f12c4e798e5d1ccc5411{padding:7px 12px}.FocusedNav-cls2__f12c4e798e5d1ccc5411.FocusedNav-useGrid__de655e1e3ea8c6cdad42{padding:7px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1__d2234dd2f6077955e3e4",
	"cls2": "FocusedNav-cls2__f12c4e798e5d1ccc5411 FocusedNav-cls1__d2234dd2f6077955e3e4",
	"useGrid": "FocusedNav-useGrid__de655e1e3ea8c6cdad42"
};
export default ___CSS_LOADER_EXPORT___;
